import { auth } from '../api/api';
import { resolveUserProfile } from '../Dashboard/dashboardService';

export const loginUser = async (credentials) => {
  const email = (credentials.email ?? '').toString().toLowerCase().trim();
  const defaultRole = email === 'admin@admin.com' ? 'Admin' : 'User';
  const payload = {
    ...credentials,
    email,
    user_role: credentials.user_role ?? defaultRole
  };
  const { data } = await auth.login(payload);
  const ok = data?.status === 'OK';
  const accessToken = data?.returnData?.access_token;
  const message = data?.errorMessage || (ok ? 'Login successful' : 'Invalid credentials');

  if (ok && accessToken) {
    const resolved = await resolveUserProfile(accessToken, email, {
      email,
      role: defaultRole,
      name: credentials.email.split('@')[0].replace(/[^a-zA-Z0-9]/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
    });

    const userData = {
      id: resolved?.id,
      name: resolved?.name || email,
      email: resolved?.email || email,
      phone: resolved?.phone ?? '',
      access_token: accessToken,
      role: resolved?.role || defaultRole
    };

    return { success: true, message, data: userData };
  }

  return { success: false, message, data: null };
};
